export default {
  WEATHER_API_KEY: '5edd218000824eb180835600201404'
}